import React, { useState, useEffect } from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import { InputField, CheckboxField, SelectField } from '../../FormFields';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { useFormikContext, Formik, Form, Field } from 'formik';

const cities = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: '1',
    label: 'New York',
  },
  {
    value: '2',
    label: 'Chicago',
  },
  {
    value: '3',
    label: 'Saigon',
  },
];

const states = [
  {
    value: undefined,
    label: 'None',
  },
  {
    value: '11',
    label: 'Florida',
  },
  {
    value: '22',
    label: 'Michigan',
  },
  {
    value: '33',
    label: 'Texas',
  },
];

const countries = [
  {
    value: null,
    label: 'None',
  },
  {
    value: '111',
    label: 'United States',
  },
  {
    value: '222',
    label: 'Italy',
  },
  {
    value: '333',
    label: 'Vietnam',
  },
];

export default function AddressForm(props) {
  const {
    formField: {
      firstName,
      lastName,
      address1,
      // address2,
      // city,
      // state,
      // zipcode,
      // country,
      // useAddressForPaymentDetails,
    },
    rhf,
  } = props;

  const { user: currentUser } = useSelector((state) => state.auth);
  const {
    useForm: { getValues },
  } = rhf;

  const getEmployee = async () => {
    console.log('getEmployee', currentUser.username);
    try {
      const { data } = await axios.get('/api/cis/employee', {
        params: { employeeId: currentUser.username },
      });
      const [{ firstName: fname, lastName, presentAddress }] = data;
      console.log('getEmployee --> ', fname);
    } catch (error) {
      console.log(error.response);
    }
  };

  // const formikProps = useFormikContext();
  // const {
  //   values: { firstName: f1, file1Name },
  // } = formikProps;
  // console.log('AddressForm-->firstName-->', f1);
  // console.log('AddressForm-->file1Name-->', file1Name);
  // if (!f1) formikProps.setFieldValue('firstName', fname);
  // const { firstName: f1, lastName: f2, address1: f3 } = formikProps;
  // setErrorMessage('');
  // const { values, submitForm } = useFormikContext();
  // setIsLoading(false);
  // setErrorMessage(
  //   error.response
  //     ? error.response.data.message || 'เกิดข้อผิดพลาดบางอย่าง'
  //     : 'เกิดข้อผิดพลาดบางอย่าง'
  // );

  useEffect(() => {
    getEmployee();
  }, []);

  return (
    <React.Fragment>
      {/* <Typography sx={{ pb: 1 }} variant="subtitle1" gutterBottom>
        Address Information : {currentUser.username}
      </Typography> */}
      <Typography variant="h6" gutterBottom>
        Address Information
        {JSON.stringify(rhf.getValues())}
      </Typography>
      <Divider sx={{ mb: 3 }} />
      <Grid container spacing={3}>
        {/* <Grid item xs={12} sm={6}>
          <InputField name={firstName.name} label={firstName.label} fullWidth />
        </Grid> */}
        {/* <Grid item xs={12} sm={6}>
          <InputField name={lastName.name} label={lastName.label} fullWidth />
        </Grid> */}
        <Grid item xs={12}>
          {/* <InputField name={address1.name} label={address1.label} fullWidth /> */}
        </Grid>
        {/* <Grid item xs={12}>
          <InputField name={address2.name} label={address2.label} fullWidth />
        </Grid> */}
        {/* <Grid item xs={12} sm={6}>
          <SelectField
            name={city.name}
            label={city.label}
            data={cities}
            fullWidth
          />
        </Grid> */}
        {/* <Grid item xs={12} sm={6}>
          <SelectField
            name={state.name}
            label={state.label}
            data={states}
            fullWidth
          />
        </Grid> */}
        {/* <Grid item xs={12} sm={6}>
          <InputField name={zipcode.name} label={zipcode.label} fullWidth />
        </Grid> */}
        {/* <Grid item xs={12} sm={6}>
          <SelectField
            name={country.name}
            label={country.label}
            data={countries}
            fullWidth
          />
        </Grid> */}
        {/* <Grid item xs={12}>
          <CheckboxField
            name={useAddressForPaymentDetails.name}
            label={useAddressForPaymentDetails.label}
          />
        </Grid> */}
      </Grid>
    </React.Fragment>
  );
}
